<app-paco-dialog [title]="'dataManagement.dataExchangeRequests.reopenDialog.title' | transloco" [actions]="dialogActions()" (actionTriggered)="onDialogAction($event)">
  <p class="intro">{{ 'dataManagement.dataExchangeRequests.reopenDialog.intro' | transloco }}</p>

  <div class="reopen-table-wrapper">
    <table mat-table [dataSource]="dataSource" class="full-width plain-table">
      <ng-container matColumnDef="select">
        <th mat-header-cell *matHeaderCellDef class="select-cell">
          <mat-checkbox
            [checked]="allSelected()"
            [indeterminate]="someSelected()"
            [disabled]="allIds().length === 0 || isSaving()"
            [attr.aria-label]="'dataManagement.dataExchangeRequests.reopenDialog.selectAll' | transloco"
            (change)="toggleAll($event.checked)">
          </mat-checkbox>
        </th>
        <td mat-cell *matCellDef="let sub" class="select-cell">
          <mat-checkbox [checked]="isSelected(sub.id)" [disabled]="isSaving()" (change)="toggle(sub.id, $event.checked)"></mat-checkbox>
        </td>
      </ng-container>

      <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef>{{ 'commonPackagingFields.id' | transloco }}</th>
        <td mat-cell *matCellDef="let sub">{{ sub.id }}</td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef>{{ 'dataManagement.dataExchangeRequests.reopenDialog.name' | transloco }}</th>
        <td mat-cell *matCellDef="let sub">{{ getName(sub) }}</td>
      </ng-container>

      <ng-container matColumnDef="articleNumber">
        <th mat-header-cell *matHeaderCellDef>{{ 'component.fields.articleNumber' | transloco }}</th>
        <td mat-cell *matCellDef="let sub">{{ getArticleNumber(sub) }}</td>
      </ng-container>

      <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef>{{ 'dataManagement.dataExchangeRequests.columns.status' | transloco }}</th>
        <td mat-cell *matCellDef="let sub">{{ getStatusLabel(sub.status) | transloco }}</td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>

      <tr class="mat-row" *matNoDataRow>
        <td class="mat-cell no-data-cell" [attr.colspan]="displayedColumns.length">
          {{ 'dataManagement.dataExchangeRequests.reopenDialog.noEligible' | transloco }}
        </td>
      </tr>
    </table>
  </div>

  <mat-paginator
    class="paginator"
    [length]="totalCount()"
    [pageIndex]="pageIndex()"
    [pageSize]="pageSize()"
    [pageSizeOptions]="pageSizeOptions"
    (page)="onPageChanged($event)">
  </mat-paginator>

  <p class="selection-summary">
    {{ 'dataManagement.dataExchangeRequests.reopenDialog.selectedCount' | transloco: { count: selectedIds().size } }}
  </p>

  <mat-form-field appearance="outline" class="full-width">
    <mat-label>{{ 'dataManagement.dataExchangeRequests.reopenDialog.commentLabel' | transloco }}</mat-label>
    <textarea matInput class="no-resize-textarea" rows="3" [formControl]="commentControl"></textarea>
  </mat-form-field>

  @if (errorMessageKey()) {
    <p class="dialog-error">{{ errorMessageKey() | transloco }}</p>
  }
</app-paco-dialog>
